import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function AppDownloadSkeleton() {
  return <Skeleton height={470} />;
}
